export default __webpack_public_path__ + "static/Shalamar Carliss-50946ebbb04dee7a3db955e51bc338f2.jpg";